import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-award',
  templateUrl: './award.component.html',
  styleUrls: ['./award.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwardIconComponent {}
